import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Table, TableLazyLoadEvent } from 'primeng/table';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { CalendarModule } from 'primeng/calendar';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import * as XLSX from 'xlsx';
import { ToolbarModule } from 'primeng/toolbar';
import { InputNumberModule } from 'primeng/inputnumber';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { ContractCalculationService } from '../contract-calculation.service';
import { HttpParams } from '@angular/common/http';
import { forkJoin, Subscription } from 'rxjs';
import { MenuModule } from 'primeng/menu';

import { Customer } from '../../master-data/customers/customers.model';
import { Business } from '../../master-data/business/business.model';

import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { ChipModule } from 'primeng/chip';
import { DropdownModule } from 'primeng/dropdown';
import { IftaLabelModule } from 'primeng/iftalabel';
import { Supplier } from '../../master-data/suppliers/suppliers.model';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { ContractCalculation, Tracker } from '../contract-calculation.model';
import { AppUser } from '../../users/user.model';
import { DatePicker } from 'primeng/datepicker';
import { SuppliersService } from '../../master-data/suppliers/suppliers.service';
import { ProcessStatus } from '../../enums/processStatus';
import { ProgressSpinner } from 'primeng/progressspinner';
import { AiStudioComponent } from '../../ai-studio/ai-studio.component';
import { ContractType } from '../../contract/contract-types';
import { Dialog } from 'primeng/dialog';
import {
  documentCategory,
  intendedUse,
  ListOfValuesService,
} from '../../listofvalues/list-of-values.service';
import { AuthenticationService } from '../../services/authentication.service';
import { ActivityTypeService } from '../../master-data/activity-type/activity-type.service';
import { ActivityType } from '../../master-data/activity-type/activity-type.model';
import { ChatSession } from '../../models/chat-session.model';
import { ChatSessionService } from '../../services/chat-session.service';
import { AuthorizationService } from '../../services/authorization.service';
import { ContractReportService } from '../../contract-report/contract-report.service';

@Component({
  selector: 'app-contract-list',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    MultiSelectModule,
    CalendarModule,
    TagModule,
    ToastModule,
    ToolbarModule,
    InputNumberModule,
    InputGroupModule,
    InputGroupAddonModule,
    ChipModule,
    DropdownModule,
    IftaLabelModule,
    ConfirmDialog,
    DatePicker,
    ProgressSpinner,
    Dialog,
    MenuModule,
  ],

  providers: [MessageService, ConfirmationService],
  templateUrl: './claim-calculation-list.component.html',
  styleUrls: ['./claim-calculation-list.component.css'],
})
export class ClaimCalculationListComponent implements OnInit, OnDestroy {
  @ViewChild('dt') dt!: Table;
  claimCalculations: ContractCalculation[] = [];
  selectedCalculations: ContractCalculation[] = [];
  selectedLineIds: number[] = [];
  totalRecords = 0;
  loading: boolean = false;
  page: number = 0;
  rows: number = 25;
  submitted: boolean = false;
  isLoading: boolean = false;
  showPopup: boolean = false;
  showJVPopup: boolean = false;
  showJVReversePopup: boolean = false;
  extraForm!: FormGroup;
  filterForm!: FormGroup;
  jvForm!: FormGroup;
  jvReverseForm!: FormGroup;
  private filterSub!: Subscription;

  private routeSub!: Subscription;
  private sessionSub!: Subscription;
  currentSessionId: number | null = null;
  currentSession: ChatSession | undefined;

  processStatus: { label: string; value: string }[] = Object.keys(ProcessStatus)
    .filter((t) =>
      [
        'NEW',
        'INPROGRESS',
        'CLAIMED',
        'ERROR',
        'ISSUEDTOSUPPLIER',
        'JVBOOKED',
        'CLAIMSETTLED',
      ].includes(t.toString()),
    )
    .map((t) => ({
      label: t.toString(),
      value: t.toString().toUpperCase(),
    }));

  contractTypes: { label: string; value: string }[] = Object.entries(
    ContractType,
  ).map(([key, value]) => ({
    label: value,
    value: key,
  }));
  sourceOptions: { label: string; value: string }[] = [
    { label: 'Receivables', value: 'RECEIVABLES' },
    { label: 'Settlement', value: 'Settlement' },
  ];

  // Options for filter dropdowns
  customers: Customer[] = [];
  filteredCustomers: Customer[] = [];
  business: Business[] = [];
  filteredBusiness: Business[] = [];
  suppliers: Supplier[] = [];
  filteredSuppliers: Supplier[] = [];
  params: HttpParams = new HttpParams();
  newListCount: number = 0;
  readyToClaimListCount: number = 0;
  issuedToSupplierListCount: number = 0;
  jvListCount: number = 0;
  setteledListCount: number = 0;
  generationType: string = 'all';
  intendedUses: intendedUse[] = [];
  filteredIntendedUses: intendedUse[] = [];
  documentCategories: documentCategory[] = [];
  filteredDocumentCategories: documentCategory[] = [];
  activityTypes: ActivityType[] = [];
  filteredActivityTypes: ActivityType[] = [];
  BusinessfilterValue: string = '';
  SupplierfilterValue: string = '';
  activityTypefilterValue: string = '';
  totalClaimAmt: number = 0;
  claimSeqNumberRequired: boolean = false;
  private authSubscription: Subscription | undefined;  

  // Permissions and inline edit state
  currentUser: AppUser | null = null;
  claimAmountEdits: { [lineId: number]: number } = {};
  savingClaim: { [lineId: number]: boolean } = {};
  actionItems: MenuItem[] = [];
  CanGenerateResult: boolean = false;

  // Credit-memo PDF preview state
  showPdfPreview: boolean = false;
  pdfLoading: boolean = false;
  pdfUrl?: SafeResourceUrl;
  pdfError?: string;
  private pdfObjectUrl?: string;

  constructor(
    private aiStudioComponent: AiStudioComponent,
    private contractCalculationService: ContractCalculationService,
    private contractReportService: ContractReportService,
    private messageService: MessageService,
    private supplierService: SuppliersService,
    private activityTypeService: ActivityTypeService,
    private listOfValuesService: ListOfValuesService,
    private chatSessionService: ChatSessionService,
    private fb: FormBuilder,
    private authService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    private authorizationService: AuthorizationService,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    let routeWithSessionId: ActivatedRoute | null = this.route;
    while (
      routeWithSessionId &&
      !routeWithSessionId.snapshot.paramMap.has('sessionId')
    ) {
      routeWithSessionId = routeWithSessionId.parent;
    }

    this.routeSub = (routeWithSessionId || this.route).paramMap.subscribe(
      (params) => {
        const sessionIdParam = params.get('sessionId');
        if (sessionIdParam) {
          if (sessionIdParam === 'current') {
            this.sessionSub = this.chatSessionService.sessions$.subscribe(
              (sessions) => {
                if (sessions && sessions.length > 0) {
                  const latest = sessions[sessions.length - 1];
                  this.currentSessionId = latest.sessionId;
                  this.currentSession = latest;
                }
              },
            );
          } else {
            const parsedId = Number(sessionIdParam);
            if (!isNaN(parsedId)) {
              this.currentSessionId = parsedId;
              this.sessionSub = this.chatSessionService.sessions$.subscribe(
                (sessions) => {
                  this.currentSession = sessions.find(
                    (s) => s.sessionId === this.currentSessionId,
                  );
                },
              );
            } else {
              const errorMsg = 'Invalid session ID in route parameters.';
              this.messageService.add({
                severity: 'error',
                summary: 'Routing Error',
                detail: errorMsg,
              });
            }
          }
        } else {
          const errorMsg = 'Session ID not found in route parameters.';
          this.messageService.add({
            severity: 'error',
            summary: 'Routing Error',
            detail: errorMsg,
          });
        }
      },
    );

    this.buildFilterForm();
    this.buildExtraForm();
    this.buildJVForm();
    this.buildJVReverseForm();
    this.loadDropdownData();
    this.updateActionItems();
    this.checkPermissions();
    this.claimSeqNumberRequired = false;

    // Load current user from session for permission checks
    this.authService.currentUser$.subscribe((user) => {
      this.currentUser = user;
    });
  }

    private checkPermissions(): void {
    this.authSubscription = this.authService.currentUser$.subscribe((user) => {
      if (user) {
        this.CanGenerateResult = this.authorizationService.hasPermission(
          user,
          'Claim Results',
          ['update']
        );
       
      } else {
        this.CanGenerateResult = false;
      }
    });
  }

  updateActionItems() {
    const isNewStatus = this.hasNewStatus();
    const isReadyToClaimStatus = this.hasReadyToClaimStatus();
    const isIssuedToSupplierStatus = this.hasIssuedToSupplierStatus();
    const isJVBookedStatus = this.hasJVBookedStatus();
    const isClaimSettledStatus = this.hasClaimSettledStatus();
    this.actionItems = [
      {
        label: `Issue DM (${this.selectedLineIds.length > 0 ? this.selectedLineIds.length : this.newListCount})`,
        icon: 'pi pi-send',
        disabled: 
          !isNewStatus ||
          (this.filterForm.controls?.['claimStatus']?.value !==
            'NEW' &&
            this.selectedLineIds.length === 0) ||
          this.newListCount === 0,
        command: () => this.submitIssueToSupplier(),
      },
      {
        label: `JV Booked (${this.selectedLineIds.length > 0 ? this.selectedLineIds.length : this.issuedToSupplierListCount})`,
        icon: 'pi pi-book',
        disabled:
          !isIssuedToSupplierStatus ||
          (this.filterForm.controls?.['claimStatus']?.value !==
            'ISSUEDTOSUPPLIER' &&
            this.selectedLineIds.length === 0) ||
          this.issuedToSupplierListCount === 0,
        command: () => this.openJVPopup(),
      },
      {
        label: `Reverse JV Booked (${this.selectedLineIds.length > 0 ? this.selectedLineIds.length : this.jvListCount})`,
        icon: 'pi pi-undo',
        disabled:
          !isJVBookedStatus ||
          (this.filterForm.controls?.['claimStatus']?.value !== 'JVBOOKED' &&
            this.selectedLineIds.length === 0) ||
          this.jvListCount === 0,
        command: () => this.openJVReversePopup(),
      },
      {
        label: `Generate Selected (${
          this.selectedLineIds.length > 0 &&
          (this.filterForm.controls?.['claimStatus']?.value ==='CLAIMSETTLED' ||
            this.filterForm.controls?.['claimStatus']?.value === 'NEW' ||
            this.filterForm.controls?.['claimStatus']?.value === 'ERROR')
            ? this.selectedLineIds.length
            : 0
        })`,
        icon: 'pi pi-check',
        disabled:
          !this.CanGenerateResult ||
          this.selectedLineIds.length === 0 ||
          !(
            this.filterForm.controls?.['claimStatus']?.value === 'CLAIMSETTLED' ||
            this.filterForm.controls?.['claimStatus']?.value === 'NEW' ||
            this.filterForm.controls?.['claimStatus']?.value === 'ERROR'
          ),
        command: ()  => this.togglePopup(true, 'selected'),
      },
      {
        label: `Generate (${
          this.filterForm.controls?.['claimStatus']?.value === 'CLAIMSETTLED'
            ? this.setteledListCount
            : this.filterForm.controls?.['claimStatus']?.value === 'NEW' ||
                this.filterForm.controls?.['claimStatus']?.value === 'ERROR'
              ? this.newListCount
              : 0
        })`,
        icon: 'pi pi-check',
        disabled:
          !this.CanGenerateResult ||
          this.filterForm.controls?.['claimStatus']?.value === 'CLAIMSETTLED'
            ? this.setteledListCount === 0
            : this.filterForm.controls?.['claimStatus']?.value === 'NEW' ||
                this.filterForm.controls?.['claimStatus']?.value === 'ERROR'
              ? !isNewStatus && this.newListCount === 0
              : true,
        command: () => this.togglePopup(true, 'all'),
      },
    ];
  }

  buildFilterForm() {
    this.filterForm = this.fb.group({
      claimStatus: [null, Validators.required],
      supplier: [null, Validators.required],
      business: [null],
      activityType: [null],
      source: [null],
      startDate: [null],
      endDate: [null],
      contractType: [null],
      rebateTrxNumber: [null],
      claimNumber: [null],
      rebateTrxStartDate: [null],
      rebateTrxEndDate: [null],
      refInvoice: [null],
      claimSeqNumber: [null],
    });
  }
  buildExtraForm() {
    this.extraForm = this.fb.group({
      documentCategory: [null],
      intendedUse: [null],
      note: [null],
      remark: [null],
      trxDate: [null],
    });
  }

  buildJVForm() {
    this.jvForm = this.fb.group({
      jvTransactionNumber: [null, Validators.required],
      // Optional note printed above the table on the credit memo report.
      description: [null],
    });
  }
  buildJVReverseForm() {
    this.jvReverseForm = this.fb.group({
      jvReversedNumber: [null, Validators.required],
      cnNumber: [null, Validators.required],
    });
  }
  openJVPopup() {
    this.showJVPopup = true;
  }
  openJVReversePopup() {
    this.showJVReversePopup = true;
  }

  submitIssueToSupplier() {
    this.submitted = true;
    if (this.filterForm.valid) {
      this.isLoading = true;
      const filterFormClone = this.filterForm.value;

      const filters: any = {
        arStatus: 'COMPLETED',
        claimStatus: filterFormClone.claimStatus,
        businessNumber: filterFormClone.business?.businessCode,
        supplier: filterFormClone.supplier?.supplierNumber,
        source: filterFormClone.source || null,

        startDate: filterFormClone.startDate
          ? this.formatToLocalDateTime(filterFormClone.startDate)
          : null,
        endDate: filterFormClone.endDate
          ? this.formatToLocalDateTime(filterFormClone.endDate, true)
          : null,
        contractType: filterFormClone.activityType?.name || null,
        // contractType: filterFormClone.contractType || null,
        rebateTrxNumber: filterFormClone.rebateTrxNumber || null,
        claimNumber: filterFormClone.claimNumber || null,
        refInvoice: filterFormClone.refInvoice || null,
        rebateTrxStartDate: filterFormClone.rebateTrxStartDate
          ? this.formatToLocalDateTime(filterFormClone.rebateTrxStartDate)
          : null,
        rebateTrxEndDate: filterFormClone.rebateTrxEndDate
          ? this.formatToLocalDateTime(filterFormClone.rebateTrxEndDate, true)
          : null,
        claimSeqNumber: filterFormClone.claimSeqNumber || null,
      };
      if (
        typeof this.currentSessionId === 'number' &&
        Number.isFinite(this.currentSessionId) &&
        this.currentSessionId > 0
      ) {
        filters['sessionId'] = this.currentSessionId;
      }

      Object.keys(filters).forEach((key) => {
        const value = filters[key];
        if (value !== null && value !== '' && value !== undefined) {
          filters[key] = value.toString();
        } else {
          delete filters[key];
        }
      });

      if (this.selectedLineIds.length > 0) {
        filters['lineIds'] = this.selectedLineIds;
      }

      this.contractCalculationService.issueToSupplier(filters).subscribe({
        next: () => {
          this.isLoading = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Issued to supplier successfully.',
          });
          setTimeout(() => {
            this.reloadPage();
          }, 1500);
        },
        error: () => {
          this.isLoading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to issue to supplier.',
          });
        },
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please Fill required fields.',
      });
    }
  }

  submitJVBooked() {
    this.submitted = true;
    if (this.jvForm.invalid) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Missing Data',
        detail: 'Please enter the JV Trx No.',
      });
      return;
    }
    const selectedStatus = this.filterForm.get('claimStatus')?.value ?? null;
    const normalized = (selectedStatus || '').toString().toUpperCase();
    const requiresSeq = [
      'JVBOOKED',
      'ISSUEDTOSUPPLIER',
      'CLAIMSETTLED',
      'APMODEL',
    ].includes(normalized);
    this.claimSeqNumberRequired = requiresSeq;
    const seqVal = this.filterForm.get('claimSeqNumber')?.value;
    if (requiresSeq && (!seqVal || seqVal.toString().trim() === '')) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Missing Data',
        detail: 'Please enter the Claim Seq Number.',
      });
      return;
    }
    const filterFormClone = this.filterForm.value;
    const filters: any = {
      arStatus: 'COMPLETED',
      claimStatus: filterFormClone.claimStatus,
      businessNumber: filterFormClone.business?.businessCode,
      supplier: filterFormClone.supplier?.supplierNumber,
      source: filterFormClone.source || null,
      activityType: filterFormClone.activityType?.name || null,
      startDate: filterFormClone.startDate
        ? this.formatToLocalDateTime(filterFormClone.startDate)
        : null,
      endDate: filterFormClone.endDate
        ? this.formatToLocalDateTime(filterFormClone.endDate, true)
        : null,
      contractType: filterFormClone.contractType || null,
      rebateTrxNumber: filterFormClone.rebateTrxNumber || null,
      claimNumber: filterFormClone.claimNumber || null,
      refInvoice: filterFormClone.refInvoice || null,
      rebateTrxStartDate: filterFormClone.rebateTrxStartDate
        ? this.formatToLocalDateTime(filterFormClone.rebateTrxStartDate)
        : null,
      rebateTrxEndDate: filterFormClone.rebateTrxEndDate
        ? this.formatToLocalDateTime(filterFormClone.rebateTrxEndDate, true)
        : null,
      claimSeqNumber: filterFormClone.claimSeqNumber || null,
    };
    Object.keys(filters).forEach((key) => {
      const value = filters[key];
      if (value !== null && value !== '' && value !== undefined) {
        filters[key] = value.toString();
      } else {
        delete filters[key];
      }
    });
    if (this.selectedLineIds.length > 0) {
      filters['lineIds'] = this.selectedLineIds;
    }
    const description = (this.jvForm.value.description ?? '').toString().trim();
    const extraData: Tracker = {
      jvTransactionNumber: this.jvForm.value.jvTransactionNumber,
      // Left out when blank so an empty box does not wipe a stored description.
      ...(description ? { description } : {}),
    };
    this.isLoading = true;
    this.contractCalculationService.bookJV(filters, extraData).subscribe({
      next: () => {
        this.isLoading = false;
        this.showJVPopup = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'JV booked successfully.',
        });
        setTimeout(() => {
          this.reloadPage();
        }, 1500);
      },
      error: () => {
        this.isLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to book JV.',
        });
      },
    });
  }
  submitJVReversalBooked() {
    this.submitted = true;
    if (this.jvReverseForm.invalid) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Missing Data',
        detail: 'Please enter both Reversal JV Trx No. and CN Number.',
      });
      return;
    }
    const selectedStatus = this.filterForm.get('claimStatus')?.value ?? null;
    const normalized = (selectedStatus || '').toString().toUpperCase();
    const requiresSeq = [
      'JVBOOKED',
      'ISSUEDTOSUPPLIER',
      'CLAIMSETTLED',
      'APMODEL',
    ].includes(normalized);
    this.claimSeqNumberRequired = requiresSeq;
    const seqVal = this.filterForm.get('claimSeqNumber')?.value;
    if (requiresSeq && (!seqVal || seqVal.toString().trim() === '')) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Missing Data',
        detail: 'Please enter the Claim Seq Number.',
      });
      return;
    }
    const filterFormClone = this.filterForm.value;
    const filters: any = {
      arStatus: 'COMPLETED',
      claimStatus: filterFormClone.claimStatus,
      businessNumber: filterFormClone.business?.businessCode,
      supplier: filterFormClone.supplier?.supplierNumber,
      source: filterFormClone.source || null,
      activityType: filterFormClone.activityType?.name || null,
      startDate: filterFormClone.startDate
        ? this.formatToLocalDateTime(filterFormClone.startDate)
        : null,
      endDate: filterFormClone.endDate
        ? this.formatToLocalDateTime(filterFormClone.endDate, true)
        : null,
      contractType: filterFormClone.contractType || null,
      rebateTrxNumber: filterFormClone.rebateTrxNumber || null,
      claimNumber: filterFormClone.claimNumber || null,
      refInvoice: filterFormClone.refInvoice || null,
      rebateTrxStartDate: filterFormClone.rebateTrxStartDate
        ? this.formatToLocalDateTime(filterFormClone.rebateTrxStartDate)
        : null,
      rebateTrxEndDate: filterFormClone.rebateTrxEndDate
        ? this.formatToLocalDateTime(filterFormClone.rebateTrxEndDate, true)
        : null,
      claimSeqNumber: filterFormClone.claimSeqNumber || null,
    };
    Object.keys(filters).forEach((key) => {
      const value = filters[key];
      if (value !== null && value !== '' && value !== undefined) {
        filters[key] = value.toString();
      } else {
        delete filters[key];
      }
    });
    if (this.selectedLineIds.length > 0) {
      filters['lineIds'] = this.selectedLineIds;
    }
    const extraData = {
      jvReversedNumber: this.jvReverseForm.value.jvReversedNumber,
      cnNumber: this.jvReverseForm.value.cnNumber,
    };
    this.isLoading = true;
    this.contractCalculationService
      .jvReversalBooked(filters, extraData)
      .subscribe({
        next: () => {
          this.isLoading = false;
          this.showJVReversePopup = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'JV reversal booked successfully.',
          });
          setTimeout(() => {
            this.reloadPage();
          }, 1500);
        },
        error: () => {
          this.isLoading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to book JV reversal.',
          });
        },
      });
  }

  loadClaimCalculations(
    event?: TableLazyLoadEvent,
    isExport = false,
    callback?: (contracts: ContractCalculation[]) => void,
  ): void {
    if (this.params.keys().length > 0) {
      this.isLoading = true;

      if (isExport) {
        this.params = this.params.set('page', 0);
        this.params = this.params.set('size', 200000);
      } else {
        this.params = this.params.set(
          'page',
          event?.first
            ? (event.first / (event.rows || this.rows)).toString()
            : this.page.toString(),
        );
        this.params = this.params.set(
          'size',
          event?.rows ? event.rows.toString() : this.rows.toString(),
        );

        if (event?.sortField) {
          this.params = this.params.set(
            'sort',
            `${event.sortField},${event.sortOrder === 1 ? 'asc' : 'desc'}`,
          );
        } else {
          this.params = this.params.set('sort', 'lineId,desc');
        }
      }

      this.contractCalculationService
        .searchContractCalculations(this.params)
        .subscribe({
          next: (resp) => {
            const linesPage = resp?.lines;
            this.totalClaimAmt = resp?.totalClaimAmt ?? 0;
            this.claimCalculations = (linesPage?.content || []).map((c) => ({
              ...c,
              claimUpdatedAt:
                this.toDateFromArray((c as any).claimUpdatedAt) ??
                c.claimUpdatedAt,
            }));
            this.totalRecords = linesPage?.totalElements ?? 0;
            this.isLoading = false;
            if (callback) {
              callback(this.claimCalculations);
            }
          },
          error: (error) => {
            this.isLoading = false;
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to load claim Calculations',
            });
          },
        });
    }
  }

  onSearch() {
    this.dt.reset();
  }

  onReset() {
    this.filterForm.reset();
    this.dt.reset();
  }
  isInvalid(controlName: string): boolean {
    const control = this.filterForm.get(controlName);
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || this.submitted)
    );
  }
  private updateClaimSeqNumberValidator(status: string | null | undefined) {
    const normalized = (status || '').toString().toUpperCase();
    this.claimSeqNumberRequired = [
      'JVBOOKED',
      'ISSUEDTOSUPPLIER',
      'CLAIMSETTLED',
      'APMODEL',
    ].includes(normalized);
  }
  hasNewStatus(): boolean {
    let allNew = false;
    this.newListCount = 0;
    if (
      this.filterForm.controls?.['claimStatus']?.value === 'NEW' ||
      this.filterForm.controls?.['claimStatus']?.value === 'ERROR'
    ) {
      if (this.claimCalculations.length === 0) {
        return false;
      }
      allNew =
        this.claimCalculations.length > 0
          ? this.claimCalculations.every(
              (item) =>
                item.claimStatus === 'NEW' || item.claimStatus === 'ERROR',
            )
          : false;

      if (allNew == true) {
        this.newListCount = this.totalRecords;
      } else {
        this.newListCount = 0;
      }
    } else {
      this.newListCount = 0;
    }

    return allNew;
  }

  hasReadyToClaimStatus(): boolean {
    let allReadyToClaim = false;
    this.readyToClaimListCount = 0;
    if (
      this.filterForm.controls?.['claimStatus']?.value === 'READYTOCLAIM' ||
      this.filterForm.controls?.['claimStatus']?.value === 'ERROR'
    ) {
      if (this.claimCalculations.length === 0) {
        return false;
      }
      allReadyToClaim =
        this.claimCalculations.length > 0
          ? this.claimCalculations.every(
              (item) =>
                item.claimStatus === 'READYTOCLAIM' ||
                item.claimStatus === 'ERROR',
            )
          : false;

      if (allReadyToClaim == true) {
        this.readyToClaimListCount = this.totalRecords;
      } else {
        this.readyToClaimListCount = 0;
      }
    } else {
      this.readyToClaimListCount = 0;
    }
    console.log(allReadyToClaim, this.readyToClaimListCount);

    return allReadyToClaim;
  }

  hasIssuedToSupplierStatus(): boolean {
    let allIssuedToSupplier = false;
    this.issuedToSupplierListCount = 0;
    if (
      this.filterForm.controls?.['claimStatus']?.value === 'ISSUEDTOSUPPLIER'
    ) {
      if (this.claimCalculations.length === 0) {
        return false;
      }
      const matchingCount = this.claimCalculations.filter(
        (item) => item.claimStatus === 'ISSUEDTOSUPPLIER',
      ).length;

      this.issuedToSupplierListCount = matchingCount;
      allIssuedToSupplier = matchingCount > 0;
    } else {
      this.issuedToSupplierListCount = 0;
    }

    return allIssuedToSupplier;
  }
  hasJVBookedStatus(): boolean {
    let anyJVBooked = false;
    this.jvListCount = 0;
    if (this.filterForm.controls?.['claimStatus']?.value === 'JVBOOKED') {
      if (this.claimCalculations.length === 0) {
        return false;
      }
      const matchingCount = this.claimCalculations.filter(
        (item) => item.claimStatus === 'JVBOOKED',
      ).length;
      this.jvListCount = matchingCount;
      anyJVBooked = matchingCount > 0;
    } else {
      this.jvListCount = 0;
    }
    return anyJVBooked;
  }
  hasClaimSettledStatus(): boolean {
    let anySettled = false;
    this.setteledListCount = 0;
    if (this.filterForm.controls?.['claimStatus']?.value === 'CLAIMSETTLED') {
      if (this.claimCalculations.length === 0) {
        return false;
      }
      const matchingCount = this.claimCalculations.filter(
        (item) => item.claimStatus === 'CLAIMSETTLED',
      ).length;
      this.setteledListCount = matchingCount;
      anySettled = matchingCount > 0;
    } else {
      this.setteledListCount = 0;
    }
    return anySettled;
  }

  submitForm(type: String) {
    this.submitted = true;
    if (this.filterForm.valid) {
      this.isLoading = true;
      const filterFormClone = this.filterForm.value;
      const extraFormClone = this.extraForm?.value;

      const filters: any = {
        arStatus: 'COMPLETED',
        claimStatus: filterFormClone.claimStatus,
        businessNumber: filterFormClone.business?.businessCode,
        supplier: filterFormClone.supplier?.supplierNumber,
        source: filterFormClone.source || null,
        activityType: filterFormClone.activityType?.name || null,
        startDate: filterFormClone.startDate
          ? this.formatToLocalDateTime(filterFormClone.startDate)
          : null,
        endDate: filterFormClone.endDate
          ? this.formatToLocalDateTime(filterFormClone.endDate, true)
          : null,
        contractType: filterFormClone.contractType || null,
        rebateTrxNumber: filterFormClone.rebateTrxNumber || null,
        claimNumber: filterFormClone.claimNumber || null,
        refInvoice: filterFormClone.refInvoice || null,
        rebateTrxStartDate: filterFormClone.rebateTrxStartDate
          ? this.formatToLocalDateTime(filterFormClone.rebateTrxStartDate)
          : null,
        rebateTrxEndDate: filterFormClone.rebateTrxEndDate
          ? this.formatToLocalDateTime(filterFormClone.rebateTrxEndDate, true)
          : null,
        claimSeqNumber: filterFormClone.claimSeqNumber || null,
      };
      if (
        typeof this.currentSessionId === 'number' &&
        Number.isFinite(this.currentSessionId) &&
        this.currentSessionId > 0
      ) {
        filters['sessionId'] = this.currentSessionId;
      }

      let method;
      if (type === 'generate') {
        this.showPopup = true;
        const extraData: any = {
          documentCategoryId: extraFormClone.documentCategory || null,
          intendedUseId: extraFormClone.intendedUse || null,
          note: extraFormClone.note || null,
          remark: extraFormClone.remark || null,
          trxDate: extraFormClone.trxDate
            ? this.formatToLocalDateTime(extraFormClone.trxDate)
            : null,
        };
        Object.keys(extraData).forEach((key) => {
          const value = extraData[key];
          if (value === null || value === '' || value === undefined) {
            delete extraData[key];
          }
        });

        Object.keys(filters).forEach((key) => {
          const value = filters[key];
          if (value !== null && value !== '' && value !== undefined) {
            filters[key] = value.toString();
          } else {
            delete filters[key];
          }
        });
        if (this.generationType === 'selected') {
          filters['lineIds'] = this.selectedLineIds;
        }

        method = this.contractCalculationService
          .generateClaimCalculation(filters, extraData)
          .subscribe({
            next: (data) => {
              this.isLoading = false;
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: 'Claim calculations generated successfully.',
              });
              setTimeout(() => {
                this.reloadPage();
              }, 2000);
            },
            error: (err) => {
              this.isLoading = false;
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to generate calculations.',
              });
            },
          });
      } else if (type === 'search') {
        Object.keys(filters).forEach((key) => {
          const value = filters[key];
          if (value !== null && value !== '' && value !== undefined) {
            this.params = this.params.set(key, value);
          } else {
            this.params = this.params.delete(key);
          }
        });
        this.dt.reset();
      }
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please Fill required fields.',
      });
    }
  }

  togglePopup(status: boolean, type: string = 'all'): void {
    this.showPopup = status;
    this.generationType = type;
  }

  loadDropdownData(): void {
    forkJoin({
      intendedUses: this.listOfValuesService.getAllIntentUse({
        page: 0,
        size: 1000,
      }),
      documentCategories: this.listOfValuesService.getAllDocumentCategory({
        page: 0,
        size: 1000,
      }),
      suppliers: this.supplierService.getAllSuppliers({
        page: 0,
        size: 1000,
        loadBusiness: true,
      }),
      activityTypes: this.activityTypeService.getAllActivityTypes({
        page: 0,
        size: 1000,
      }),
    }).subscribe({
      next: (data) => {
        this.suppliers = data.suppliers.content;
        this.filteredSuppliers = this.suppliers;

        this.intendedUses = data.intendedUses.content;
        this.filteredIntendedUses = this.intendedUses;
        this.documentCategories = data.documentCategories.content;
        this.filteredDocumentCategories = this.documentCategories;
        this.activityTypes = data.activityTypes.content;
        this.filteredActivityTypes = data.activityTypes.content;
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load filter options.',
        });
        console.error('Error loading dropdown data:', err);
      },
    });
  }

  filterCustomers(event: any) {
    if (!event.target.value || event.target.value.length === 0) {
      this.filteredCustomers = this.customers;
    } else {
      this.filteredCustomers = this.customers.filter(
        (customer) =>
          customer.customerName
            .toLowerCase()
            .includes(event.target.value.toLowerCase()) ||
          customer.customerNumber
            .toLowerCase()
            .includes(event.target.value.toLowerCase()),
      );
    }
  }

  filterBusinesses(event: any) {
    this.BusinessfilterValue = event.target.value;
    if (!event.target.value || event.target.value.length === 0) {
      this.filteredBusiness = this.business;
    } else {
      this.filteredBusiness = this.business.filter(
        (business) =>
          business.businessName
            .toLowerCase()
            .includes(event.target.value.toLowerCase()) ||
          business.businessCode
            ?.toLowerCase()
            .includes(event.target.value.toLowerCase()),
      );
    }
  }

  filterSuppliers(event: any) {
    this.SupplierfilterValue = event.target.value;
    if (!event.target.value || event.target.value.length === 0) {
      this.filteredSuppliers = this.suppliers;
    } else {
      this.filteredSuppliers = this.suppliers.filter(
        (supplier) =>
          supplier.supplierName
            .toLowerCase()
            .includes(event.target.value.toLowerCase()) ||
          supplier.supplierNumber
            ?.toLowerCase()
            .includes(event.target.value.toLowerCase()),
      );
    }
  }
  filterActivityTypes(event: any) {
    this.activityTypefilterValue = event.target.value;
    if (!event.target.value || event.target.value.length === 0) {
      this.filteredActivityTypes = this.activityTypes;
    } else {
      this.filteredActivityTypes = this.activityTypes.filter((activityType) =>
        activityType.name
          .toLowerCase()
          .includes(event.target.value.toLowerCase()),
      );
    }
  }

  onLazyLoad(event: any) {
    this.loadClaimCalculations(event, false);
  }

  clear(table: Table): void {
    table.clear();
  }

  onSelectionChange(selected: ContractCalculation[]) {
    this.selectedCalculations = selected || [];
    this.selectedLineIds = this.getSelectedLineIds();
    this.updateActionItems();
  }

  getSelectedLineIds(): number[] {
    return (this.selectedCalculations || [])
      .map((c) => c.lineId)
      .filter((id): id is number => typeof id === 'number');
  }

  canShowHeaderCheckbox(): boolean {
    const rows = this.claimCalculations || [];
    if (rows.length === 0) return true;
    return rows.every(
      (c) => c.claimStatus === 'NEW' || c.claimStatus === 'ERROR',
    );
  }

  formatToLocalDateTime(date: Date, endOfDay = false): string {
    if (!date) return '';

    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    // const hours = endOfDay ? 23 : 0;
    // const minutes = endOfDay ? 59 : 0;
    // const seconds = endOfDay ? 59 : 0;

    return `${year}-${month}-${day}`;
    // T${String(hours).padStart(2, '0')}:${String(
    //   minutes
    // ).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }

  // Converts arrays from Java time serialization to JS Date
  // Format: [year, month, day, hour, minute, second, nanosecond]
  private toDateFromArray(raw: any): Date | null {
    if (!raw) return null;
    if (raw instanceof Date) return raw;
    if (Array.isArray(raw)) {
      const [year, month, day, hour, minute, second, nano] = raw;
      if (
        typeof year !== 'number' ||
        typeof month !== 'number' ||
        typeof day !== 'number'
      ) {
        return null;
      }
      const ms = Math.floor((nano || 0) / 1_000_000); // nanos → millis
      return new Date(
        year,
        month - 1,
        day,
        hour || 0,
        minute || 0,
        second || 0,
        ms,
      );
    }
    // Try parsing strings or epoch values
    try {
      const d = new Date(raw);
      return isNaN(d.getTime()) ? null : d;
    } catch {
      return null;
    }
  }

  onSupplierChange(supplier: Supplier) {
    this.business = supplier.business ?? [];
    this.filteredBusiness = supplier.business ?? [];

    this.filterForm.controls['business'].reset();
    if (this.filteredBusiness.length === 1) {
      this.filterForm.controls['business'].setValue(this.filteredBusiness[0]);
    }
    this.filterForm.controls['supplier'].setValue(supplier);
  }

  exportExcel() {
    this.loadClaimCalculations(
      undefined,
      true,
      (contractCalculations: ContractCalculation[]) => {
        const dataToExport = contractCalculations.map((contractCalc) => ({
          'Vendor Number': contractCalc.vendorNumber,
          'Business Name': contractCalc.businessName,
          Business: contractCalc.business,
          'AR Status': contractCalc.arStatus,
          Source: contractCalc.source,
          Type: contractCalc.type,
          Period: contractCalc.period,
          'Line ID': contractCalc.lineId,
          'Contract Number': contractCalc.contractNo,
          'Customer ID': contractCalc.customerId,
          'Customer Number': contractCalc.customerNumber,
          'Customer Name': contractCalc.customerName,
          'Bill To': contractCalc.billTo,
          'Vendor Site Number': contractCalc.vendorSiteNumber,

          'Ledger ID': contractCalc.ledgerId,
          Division: contractCalc.division,
          Entity: contractCalc.entity,
          'Organization ID': contractCalc.orgId,
          'Claim Status': contractCalc.claimStatus,
          'Integration Status': contractCalc.integrationStatus,
          'Reference Customer Transaction ID': contractCalc.refCustomerTrxId,
          'Reference Customer Transaction Line ID':
            contractCalc.refCustomerTrxLineId,
          'Site Number': contractCalc.siteNumber,
          'Site Name': contractCalc.siteName,
          'Address 2': contractCalc.address1,
          'Address 3': contractCalc.address2,
          Area: contractCalc.area,
          City: contractCalc.city,
          'Reference Invoice': contractCalc.refInvoice,
          'Reference Invoice Date': contractCalc.refInvDate
            ? this.formatToLocalDateTime(contractCalc.refInvDate)
            : '',
          'Item Code': contractCalc.itemCode,
          'Vendor Catalog': contractCalc.vendorCatalog,
          'Item Description': contractCalc.itemDesc,
          'Unit Standard Price': contractCalc.unitStandardPrice,
          'Unit Price': contractCalc.unitePrice,
          'Invoice Quantity': contractCalc.invQty,
          'Invoice Amount': contractCalc.invAmount,
          'Rebate Transaction Number': contractCalc.rebateTrxNumber,
          'Rebate Transaction Date': contractCalc.rebateTrxDate
            ? this.formatToLocalDateTime(contractCalc.rebateTrxDate)
            : '',
          'Rebate Percent': contractCalc.rebatePercent,
          'Rebate Amount': contractCalc.rebateAmount,
          'Claim Percent': contractCalc.claimPercent,
          'Claim Amount': contractCalc.claimAmt,
          'Claim VAT': contractCalc.claimVat,
          'Claim Batch ID': contractCalc.claimBatchId,
          'Claim Number': contractCalc.claimNumber,
          'ERP AP Transaction ID': contractCalc.erpApTrxId,
          'ERP AP Transaction Number': contractCalc.erpApTrxNo,
          'ERP AP Transaction Date': contractCalc.erpApTrxDate,
          'AP GL Segments':
            contractCalc.apGlSegment1 +
            '-' +
            contractCalc.apGlSegment2 +
            '-' +
            contractCalc.apGlSegment3 +
            '-' +
            contractCalc.apGlSegment4 +
            '-' +
            contractCalc.apGlSegment5 +
            '-' +
            contractCalc.apGlSegment6 +
            '-' +
            contractCalc.apGlSegment7 +
            '-' +
            contractCalc.apGlSegment8 +
            '-' +
            contractCalc.apGlSegment9 +
            '-' +
            contractCalc.apGlSegment10,
        }));
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Contracts');
        XLSX.writeFile(wb, 'rebate_result_Export.xlsx');
      },
    );
  }

  // UI permission to edit claim
  canEditClaim(row: ContractCalculation): boolean {
    return row.claimStatus === 'NEW' && !!this.currentUser?.canChangeClaim;
  }

  // Save edited claim amount
  saveClaimAmount(row: ContractCalculation): void {
    const lineId = row.lineId;
    if (lineId == null) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Missing line ID for this row.',
      });
      return;
    }

    let newAmount = this.claimAmountEdits[lineId] ?? row.claimAmt;
    if (newAmount == null || isNaN(Number(newAmount))) {
      this.messageService.add({
        severity: 'warn',
        summary: 'No Change',
        detail: 'Please enter a valid claim amount.',
      });
      return;
    }
    // No clamping: allow negative and up to two fraction digits (handled by input)
    newAmount = Number(newAmount);
    this.claimAmountEdits[lineId] = newAmount;

    this.savingClaim[lineId] = true;
    this.contractCalculationService
      .updateClaimAmount(lineId, Number(newAmount))
      .subscribe({
        next: (updated) => {
          row.claimAmt = updated?.claimAmt ?? Number(newAmount);
          this.messageService.add({
            severity: 'success',
            summary: 'Saved',
            detail: 'Claim amount updated.',
          });
          this.savingClaim[lineId] = false;
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to update claim amount.',
          });
          this.savingClaim[lineId] = false;
        },
      });
  }

  // Handle input change without clamping
  onClaimAmountChange(lineId: number | null | undefined, value: any): void {
    if (lineId == null) return;
    const numeric = Number(value);
    if (isNaN(numeric)) return;
    this.claimAmountEdits[lineId] = numeric;
  }

  reloadPage() {
    this.aiStudioComponent.reloadPage();
  }

  // Preview the credit-memo contract report for the currently filtered supplier
  previewCreditMemoPdf(): void {
    const supplierNo = this.filterForm.controls['supplier']?.value
      ?.supplierNumber;
    const claimSeqNumber =
      this.filterForm.controls['claimSeqNumber']?.value || null;
    if (!supplierNo) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Missing Data',
        detail: 'Please select a supplier first.',
      });
      return;
    }
    if (!claimSeqNumber) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Missing Data',
        detail: 'Please enter a claim sequence number first.',
      });
      return;
    }

    this.pdfLoading = true;
    this.pdfError = undefined;
    this.revokePdfPreview();
    this.showPdfPreview = true;

    this.contractReportService
      .getCreditMemoPdf({ supplierNo, claimSeqNumber })
      .subscribe({
        next: (blob) => {
          this.pdfObjectUrl = window.URL.createObjectURL(blob);
          this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
            this.pdfObjectUrl,
          );
          this.pdfLoading = false;
        },
        error: async (err) => {
          this.pdfLoading = false;
          this.pdfError =
            (await this.readErrorBlob(err?.error)) ??
            'Failed to load the report.';
        },
      });
  }

  closePdfPreview(): void {
    this.showPdfPreview = false;
    this.revokePdfPreview();
  }

  private revokePdfPreview(): void {
    if (this.pdfObjectUrl) {
      window.URL.revokeObjectURL(this.pdfObjectUrl);
      this.pdfObjectUrl = undefined;
    }
    this.pdfUrl = undefined;
  }

  private async readErrorBlob(body: unknown): Promise<string | null> {
    if (body instanceof Blob) {
      const text = await body.text();
      try {
        return JSON.parse(text)?.message ?? text;
      } catch {
        return text;
      }
    }
    return null;
  }

  ngOnDestroy(): void {
    this.revokePdfPreview();
  }
}
